/**
 * I marchi, e quali sono accesi.
 *
 * Il vero interruttore sta sul server (`MARCHI_SPENTI` nella edge function
 * `chat`): e' li' che si decide cosa l'installatore riceve, e nessuna scelta
 * fatta nel browser puo' scavalcarlo. Questo elenco serve solo a non MOSTRARE
 * un marchio che poi non risponderebbe - nel pannello admin, nei filtri, negli
 * esempi.
 *
 * Deciso il 27/08: INIM resta spento finche' Umberto non torna con la
 * liberatoria (o con una chiave in sola lettura sul loro database). E' l'unico
 * costruttore che vieta testualmente la riproduzione, ed e' il marchio di tutti
 * gli 87 schemi che ripubblichiamo.
 *
 * RIACCESO IL 09/10/2026: INIM ha dato il consenso (Davide: «abbiamo il
 * consenso, riattivare INIM sull'app e ovunque»). L'elenco resta, vuoto: e'
 * l'interruttore per il prossimo marchio da sospendere. Si cambia sempre
 * insieme alla variabile del server (`MARCHI_SOSPESI`, letta da
 * supabase/functions/_shared/marchi.ts).
 */
export const MARCHI_ESISTENTI = ["INIM", "AJAX", "DAITEM", "NOTIFIER"] as const;
export type Marchio = (typeof MARCHI_ESISTENTI)[number];

/** Da cambiare insieme alla variabile del server, mai uno solo dei due. */
export const MARCHI_SPENTI: readonly string[] = [];

export const MARCHI: readonly Marchio[] = MARCHI_ESISTENTI.filter(
  (m) => !MARCHI_SPENTI.includes(m),
);

/**
 * Un marchio e' acceso se non sta fra gli spenti.
 *
 * Si confronta la parte PRIMA dell'underscore: nell'archivio esiste
 * `INIM_EXTRA`, che e' lo stesso costruttore di `INIM` con un'altra raccolta di
 * documenti. Confrontando la stringa intera passava indenne, e il 10/09/2026 e'
 * successo davvero: nel glossario le voci `INIM_EXTRA` restavano visibili a
 * tutti mentre le `INIM` sparivano. La regola sta qui e non in chi chiama,
 * cosi' vale anche per il prossimo che la usera'.
 */
export function marchioAcceso(m: string): boolean {
  const base = m.split("_")[0].toUpperCase();
  return !MARCHI_SPENTI.includes(base);
}

/**
 * Il team Datacom (mail @datacomtecnologie.it) vede anche i marchi spenti:
 * consulta i manuali del proprio fornitore, non li ripubblica (Davide,
 * 02/09/2026). La decisione vera la prende il server, che legge la mail con
 * la chiave segreta; qui serve solo a non nascondere INIM negli esempi.
 */
export function utenteInterno(email?: string | null): boolean {
  return /@(datacomtecnologie\.it|b2brand\.it)$/i.test((email ?? "").trim());
}
